import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var listItemContentMediaClassName = 'ui-list__itemcontentmedia';

/**
 * Provides a content media for the ListItem.
 */
export var ListItemContentMedia = /*#__PURE__*/function () {
  var ListItemContentMedia = compose(Box, {
    className: listItemContentMediaClassName,
    displayName: 'ListItemContentMedia',
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  ListItemContentMedia.propTypes = commonPropTypes.createCommon();
  return ListItemContentMedia;
}();
//# sourceMappingURL=ListItemContentMedia.js.map
